let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '客户手机号',
        props: 'mobile',
        minWidth: 200,
    },
    {
        label: '注册时间',
        props: 'registerTime',
        minWidth: 200,
        sortable:true,
    },
    {
        label: '注册来源',
        props: 'registerSource',
        minWidth: 200,
        sortable:true,
    },
    {
        label: '最近登录时间',
        props: 'loginTime',
        minWidth: 200,
        sortable:true,
    },
    {
        label: '最近登录来源',
        props: 'loginSource',
        minWidth: 200,
        sortable:true,
    },
    {
        label: '首次充电',
        props: 'firstChargeDate',
        minWidth: 200,
        // formatter: function formatter(row, column, cellValue, index) {
        //     // 做判断
        //     if (row.custDto) {
        //         return row.custDto.firstChargeDate;
        //     }
        //     else {
        //         return ''
        //     }
        // }
    },
    {
        label: '最近充电',
        props: 'latestChargeDate',
        minWidth: 200,
        // formatter: function formatter(row, column, cellValue, index) {
        //     // 做判断
        //     if (row.custDto) {
        //         return row.custDto.latestChargeDate;
        //     }
        //     else {
        //         return ''
        //     }
        // }
    },
    {
        label: '充电费用（元）',
        props: 'custDto',
        minWidth: 200,
        sortable:true,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.custDto) {
                return row.custDto.chargeFee;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '充电量（kW·h）',
        props: 'custDto',
        minWidth: 200,
        sortable:true,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.custDto) {
                return row.custDto.chargeVal;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '充电次数',
        props: 'custDto',
        minWidth: 120,
        sortable:true,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.custDto) {
                return row.custDto.chargeCount;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '客户标签',
        props: 'configName',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.custDto) {
                return row.custDto.custTypeName;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '运营商',
        props: 'dealName',
        minWidth: 200,
        // formatter: function formatter(row, column, cellValue, index) {
        //     // 做判断
        //     if (row.custDto) {
        //         return row.custDto.dealNames;
        //     }
        //     else {
        //         return ''
        //     }
        // }
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 180,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.custDto) {
                return row.custDto.remark;
            }
            else {
                return ''
            }
        }
    },
];

// 列表展示项
pageConfig.dialogListColumns = [
    {
        label: '标签名称',
        props: 'configName',
        minWidth: 200,
    },
    {
        label: '创建人',
        props: 'createdByName',
        minWidth: 300,
        tooltip:true,
    },
    {
        label: '标签数量',
        props: 'configDisp',
        minWidth: 200,
    },
];

// 列表展示项
pageConfig.custDetailColumns = [
    {
        label: '操作时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
    {
        label: '充值金额（元）',
        props: 'inExpAmount',
        minWidth: 200,
        tooltip:true,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.operateType == '01') {
                return row.inExpAmount;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '退款金额（元）',
        props: 'inExpAmount',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
            // 做判断
            if (row.operateType == '07') {
                return row.inExpAmount;
            }
            else {
                return ''
            }
        }
    },
    {
        label: '账户剩余金额（元）',
        props: 'changeFreeBal',
        minWidth: 200,
    },
    {
        label: '操作人',
        props: 'lastModifiedByName',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
];

// 列表展示项
pageConfig.custkWhDetailColumns = [
    {
        label: '度电',
        props: 'chargeValue',
        minWidth: 200,
    },
    {
        label: '账户剩余度电',
        props: 'chargeBalanceValue',
        minWidth: 200,
        // tooltip:true,
        // formatter: function formatter(row, column, cellValue, index) {
        //     // 做判断
        //     if (row.operateType == '01') {
        //         return row.inExpAmount;
        //     }
        //     else {
        //         return ''
        //     }
        // }
    },
    {
        label: '操作人',
        props: 'createdByName',
        minWidth: 200,
        // formatter: function formatter(row, column, cellValue, index) {
        //     // 做判断
        //     if (row.operateType == '07') {
        //         return row.inExpAmount;
        //     }
        //     else {
        //         return ''
        //     }
        // }
    },
    {
        label: '操作时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    {
        label: '备注',
        props: 'remark',
        minWidth: 200,
    },
];

// 车辆信息列表
pageConfig.carsListColumns = [
    {
        label: '用户手机号',
        props: 'custPhone',
        minWidth: 200,
    },
    {
        label: '所属地区',
        props: 'vehicleRegion',
        minWidth: 200,
    },
    {
        label: '车辆型号',
        props: 'vehicleModel',
        minWidth: 200,
    },
    {
        label: '车牌号',
        props: 'vehicleNumber',
        minWidth: 200,
    },
    {
        label: '图片',
        props: '',
        minWidth: 200,
    },
    {
        label: '创建时间',
        props: '',
        minWidth: 200,
    },
]

// // 面包屑
pageConfig.listBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'title',
    name: '客户管理'
},];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// dialog列表-表格属性
pageConfig.dialogTableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

// 列表-分页参数
pageConfig.detailPagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 车辆信息 - 分页参数
pageConfig.carPagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}
// 列表-编辑操作
pageConfig.tableEditObj = {
    editKey: 'id',
    editRouter: 'pileModelDetail',
};

// 路由
pageConfig.listRouter = 'custManageList';

pageConfig.custDeatilRouter = 'custDetail';

// 详情的面包屑
pageConfig.detailBreadCrumb = [{
    type: 'title',
    name: '首页',
},
{
    type: 'router',
    name: '客户管理',
    router: 'custManageList'
},
{
    type: 'title',
    name: '客户详情',
}];

pageConfig.formRules = {
    pileTypeName: [{
        required: true,
        message: '请填写充电桩型号名称',
        trigger: 'blur'
    }],
};

pageConfig.labelFormRules = {
    configName: [{
        required: true,
        message: '请填写标签名称',
        trigger: 'blur'
    }],
    configVal: [{
        required: true,
        message: '请填写编号',
        trigger: 'blur'
    }],
};

pageConfig.dealerFormRules = {
    dealerNo: [{
        required: true,
        message: '请填写运营商全称',
        trigger: 'blur'
    }],
    mobile: [{
        required: true,
        message: '请填写客户手机号',
        trigger: 'blur'
    },
    {
        pattern: /^((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
        message: '手机号填写错误',
        trigger: 'blur'
    }],
};

pageConfig.selectFormRules = {
    remark: [{
        required: true,
        message: '请填写备注',
        trigger: 'blur'
    }],
    chargeValue: [
        {
        required: true,
        message: '请输入充值度电',
        trigger: 'blur'
    }
    ],
};

pageConfig.remarkFormRules = {
    remark: [{
        required: true,
        message: '请填写备注',
        trigger: 'blur'
    }],
};

export default pageConfig;